import changeIsLoading from '../../actions/changeIsLoading';
import initializeWeekStartOptionViewState from '../../actions/weekStart/initializeWeekStartOptionViewState';
import loadWeekStartOption from '../../actions/weekStart/loadWeekStartOption';
import { orchestrator } from 'satcheljs';

const loadWeekStartOptionOrchestrator = orchestrator(loadWeekStartOption, (actionMessage: {}) => {
    changeIsLoading(true);
    initializeWeekStartOptionViewState();
    changeIsLoading(false);
});

export default loadWeekStartOptionOrchestrator;
